import React from "react";
import { Card, CardColor } from "../types/game";
import { CardTheme } from "./types";
import { CardSymbol } from "./CardSymbol";
import { CardBackground } from "./CardBackground";

interface CardFrontProps {
  card: Card;
  theme: CardTheme;
}

export const CardFront: React.FC<CardFrontProps> = React.memo(({ card, theme }) => {
  const { width, height, radius, ovalColor } = theme.card;
  const centerX = width / 2;
  const centerY = height / 2;
  const ovalWidth = width * 0.6;
  const ovalHeight = height * 0.5;

  // Get card color - CardColor enum values are strings that match theme keys
  // CardColor.RED = "red", CardColor.BLUE = "blue", etc.
  const getCardColor = (color: CardColor): string => {
    switch (color) {
      case CardColor.RED:
        return theme.colors.red;
      case CardColor.BLUE:
        return theme.colors.blue;
      case CardColor.GREEN:
        return theme.colors.green;
      case CardColor.YELLOW:
        return theme.colors.yellow;
      case CardColor.WILD:
        return theme.colors.wild;
      default:
        // Fallback - try to use enum value as string key
        const colorStr = String(color);
        if (colorStr in theme.colors) {
          return theme.colors[colorStr as keyof typeof theme.colors];
        }
        return theme.colors.wild;
    }
  };

  const cardColor = getCardColor(card.color);

  return (
    <g>
      {/* Card background - handles both color and image backgrounds */}
      <CardBackground color={cardColor} theme={theme} />

      {/* White oval in center */}
      <ellipse
        cx={centerX}
        cy={centerY}
        rx={ovalWidth / 2}
        ry={ovalHeight / 2}
        fill={ovalColor}
      />

      {/* Card symbol */}
      <CardSymbol card={card} theme={theme} />
    </g>
  );
});

CardFront.displayName = "CardFront";
